import React from 'react';
import { getIn, useFormikContext } from 'formik';
import { IAreaInputProps, AreaInput } from '../AreaInput';

interface IAreaField extends Partial<IAreaInputProps> {
  name: string;
}
//FYI: this simplifies integration with Formik. See README
export const AreaField: React.FC<IAreaField> = ({ name, ...rest }) => {
  const formik = useFormikContext();
  const onChange = (value: any) => {
    formik.setFieldTouched(name as never);
    formik.setFieldValue(name as never, value);
    if (rest.onChange) {
      rest.onChange(value);
    }
  };
  const value = getIn(formik.values, name);
  const errorText =
    (!!formik.submitCount || !!getIn(formik.touched, name)) && !!getIn(formik.errors, name)
      ? getIn(formik.errors, name)
      : null;
  return (
    <AreaInput
      {...rest}
      value={value}
      onChange={onChange}
      errorText={errorText}
      data-test-id={rest['data-test-id'] || name}
    />
  );
};
